<div class="filter-item-global">
    <p-dropdown *ngIf="!hideCustomerFilter" data-cy="customer-filter" class="min-width300" #customerFilter [options]="customerList" [(ngModel)]="selectedCustomer"
        [filter]="true" filterBy="label,name" [virtualScroll]="true" virtualScrollItemSize="30" placeholder="Customers" optionLabel="name"
        (onChange)="onCustomerChosen()">
    </p-dropdown>
</div>